import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { ParentSummary } from '../../lib/types.ts';
import { isFreed } from './format.ts';

interface Props {
  /** Родитель как его отдаёт API: обе оси рядом (archivedAt + file). */
  parent: ParentSummary;
  /** 'film' — родитель клипа; 'clip' — родитель варианта. */
  kind: 'film' | 'clip';
}

/**
 * Ссылка вверх + честный статус родителя под ней (прототип §5).
 *
 * Красный чип — производное от состояния ФАЙЛА, а не от архивности: только
 * освобождённый исходник/foundation реально отнимает способность. Архивный
 * родитель с целым файлом — нейтральное «в архиве». Файла ещё нет ('absent') —
 * тоже не потеря, родитель просто «активен».
 */
export function ParentLink({ parent, kind }: Props) {
  const { t } = useTranslation();
  const to = kind === 'film' ? `/films/${parent.id}` : `/clips/${parent.id}`;

  let chip;
  if (isFreed(parent.file)) {
    chip = (
      <span className="chip err">
        {kind === 'film' ? t('archive.parent.sourceFreed') : t('archive.parent.foundationFreed')}
      </span>
    );
  } else if (parent.archivedAt) {
    chip = <span className="chip arch">{t('archive.chip.archived')}</span>;
  } else {
    chip = <span className="chip ok">{t('archive.parent.active')}</span>;
  }

  return (
    <div>
      <Link to={to} style={{ color: 'var(--neon)', fontWeight: 600 }}>
        {parent.title}
      </Link>
      <div style={{ marginTop: 3 }}>{chip}</div>
    </div>
  );
}
